<script setup lang="ts">
import { isEmpty } from 'es-toolkit/compat'

definePageMeta({
    middleware: ['guest-only'],
})

const { site } = useCoreConfig()

// SEO - START
const { data: pageData } = await usePageData('bonuskode')

const { getHead, getSeoMeta } = useContentSeo(
    pageData.value?.seo || {
        metaTitle: `${site.title} Bonuskode | Læs mere om ${site.title} kampagner her`,
        metaDescription: 'Vi tilbyder alle nye spillere en bonus. Det kan enten være en engangsbonus eller en forøgelse af første indskud. Regler & Vilkår gælder | 18+'
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
// SEO - END
</script>

<template>
    <div class="bonuskode">
        <LazyNimbusContentDynamicRenderer
            v-if="!isEmpty(pageData?.dynamicContent)"
            :content="pageData?.dynamicContent"
            :max-width="1024"
        />
        <p v-else>
            Der skete en fejl ved hentning af bonuskode-siden. Prøv venligst igen om et øjeblik.
        </p>
    </div>
</template>
